import { endpoints } from '../constants/endpoints';
import { postFileRequest, postRequest } from '../helpers/request';
import { setDelay } from '../redux/actions/shared';
import { store } from '../redux/store/store';

/**
 * Update bifrost data AND perform migrate (depending on the tier)
 * @param {Object} tier
 * @param {String} userIdBifrost
 * @param {Boolean} migrate
 * @param {String} productRequestId
 * @returns
 */
export const migrateSubmit = async (tier, userIdBifrost, migrate, productRequestId) => {
  try {
    let payload = {
      'bifrost_user_id': userIdBifrost.toString(),
      'tier': tier.unique_name,
      'product_request_id': productRequestId.toString()
    };
    let response;

    if (localStorage.getItem('idRequest')){
      payload.product_request_id = localStorage.getItem('idRequest');
    }

    payload.new_verification_level = tier.verification_level;
    response = await postRequest(endpoints.updateBifrost, payload);
    if (migrate) {
      store.dispatch(setDelay(true));
      response = await postRequest(endpoints.migrate, payload);
    }
    return response;
  } catch (error) {
    console.error('migrateSubmit: ', error);
    store.dispatch(setDelay(false));
  }
};

/**
 * Upload documents files AND perform migrate (depending on the tier)
 * @param {Object} tier
 * @param {String} userIdBifrost
 * @param {Boolean} migrate
 * @param {String} productRequestId
 * @returns
 */
export const uploadFilesAndMigrateSubmit = async (payload, payloadUpdateBifrost) => {
  try {
    let response;

    const responseBifrost = await postRequest(endpoints.updateBifrost, payloadUpdateBifrost);
    response = await postFileRequest(endpoints.userFilesFullAndMigrate, payload, true);
    store.dispatch(setDelay(true));
    return response;
  } catch (error) {
    console.error('migrateSubmit: ', error);
    store.dispatch(setDelay(false));
  }
};